import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchPushOperation } from '@/services/git/api';
import type { PushOperation } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

const TERMINAL = new Set(['completed', 'failed']);

export function usePushOperation(pushOperationId: string | null | undefined): UseQueryResult<PushOperation, Error> {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['pushOperation', pushOperationId],
    queryFn: () => fetchPushOperation(orgId!, pushOperationId!),
    enabled: !!pushOperationId && !!orgId,
    retry: 0,
    refetchInterval: (query) => {
      if (query.state.status === 'error') return false;
      const status = query.state.data?.status;
      return status && TERMINAL.has(status) ? false : 2000;
    },
    staleTime: 0,
  });
}
